import React, {useEffect, useState, useRef} from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space} from 'antd';
import {getAll, drop} from '../../../../apis/IncapacidadEmpleadoApi';
import { getList as getTiposIncapacidades } from '../../../../apis/TipoIncapacidadApi';

import { getEmpleados } from '../../../../apis/OdooApi';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catálogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Incapacidad del Empleado</span>
      </>
    ),
}];

const IncapacidadEmpleado = () => {
    const [items, setItems] = useState([]);
    const [empleados, setEmpleados] = React.useState([]);
    const [tiposIncapacidad, setTiposIncapacidad] = React.useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [objectSelected, setobjectSelected] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadCatalogs = async () => {
      try {
        const [resEmpleados, resTiposIncapacidad] = await Promise.all([
          getEmpleados(),
          getTiposIncapacidades()
        ]);
        console.log("[INC][getEmpleados] payload:", resEmpleados?.payload?.slice?.(0,3));
        console.log("[INC][getTiposIncapacidades] payload:", resTiposIncapacidad?.payload?.slice?.(0,3));

        if (resEmpleados.ok) setEmpleados(resEmpleados.payload);
        if (resTiposIncapacidad.ok) setTiposIncapacidad(resTiposIncapacidad.payload);
      } catch (err) {
        console.error("Error cargando catálogos:", err);
      }
    };

    const getTipoIncapacidadNombre = (id) => {
      const t = tiposIncapacidad.find(x => Number(x.value) === Number(id));
      return t ? `${t.displayTitle}` : `ID ${id}`;
    };

    const getEmpleadoNombre = (id) => {
      const emp = empleados.find(e => e.value === id);
      return emp ? emp.text : `ID ${id}`;
    };

    const getTipovControlNombre = (id) => {
      const mapa = {
        0: "Ninguno",
        1: "Única",
        2: "Inicial",
        3: "Subsecuente",
        4: "Alta Médica ó ST-2",
        5: "Prenatal",
        6: "Enlance",
        7: "PostNatal"
      };
      return mapa[id] || "Desconocido";
    };
    const columns = [
      {
        title: 'Empleado',
        dataIndex: 'empleado_id',
        key: 'empleado_id',
        render: (value) => getEmpleadoNombre(value),
      },
      {
        title: 'Tipo Incapacidad',
        dataIndex: 'tipo_incapacidad_id',
        key: 'tipo_incapacidad_id',
        render: (value) => getTipoIncapacidadNombre(value),
      },
      {
        title: 'Fecha Inicial',
        dataIndex: 'fecha_inicial',
        key: 'fecha_inicial',
      },
      {
        title: 'Días Incapacidad',
        dataIndex: 'dias_incapacidad',
        key: 'dias_incapacidad',
      },
      {
        title: 'Fecha Final',
        dataIndex: 'fecha_final',
        key: 'fecha_final',
      },
      {
        title: 'Número Incapacidad',
        dataIndex: 'numero_incapacidad',
        key: 'numero_incapacidad',
      },
      {
        title: 'Control',
        dataIndex: 'control',
        key: 'control',
        render: (value) => getTipovControlNombre(value),
      },
      {
        title: '% Permanente',
        dataIndex: 'porcentaje_perm',
        key: 'porcentaje_perm',
        render: (value) => `${value}%`
      },
      {
        title: 'Secuela',
        dataIndex: 'secuela',
        key: 'secuela',
        render: (value) => value === 1 ? 'Sí' : 'No'
      },
      {
        title: 'Acciones',
        key: 'actions',
        render: (_, record) => (
          <Space>
            <Button type='primary' size='small' onClick={() => openDetails(record)}>
              Editar
            </Button>
            <Button type='primary' size='small' danger onClick={() => deleteConfirm(record)}>
              Eliminar
            </Button>
          </Space>
        ),
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setobjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar la variable?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡La variable ha sido eliminada!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setobjectSelected(null);
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }

      setLoading(false);
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await loadCatalogs();
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    return <PageApp 
      routes={routes}
      title={'Incapacidades'} 
      cardTitle='Lista de incapacidades de empleados'
      extraCard={[
        <Button type="primary" onClick={btnClick}>
          Agregar Incapacidad
      </Button>
      ]}>
      {
          loading ? (
            <p>Loading...</p>
          ) : <>
            {
              items.length == 0 ? <Empty />:
              <Table dataSource={items} columns={columns} />
            }
          </>
      }
      {
        (openEdit && objectSelected && objectSelected.id > 0) &&
        <ModalEdit title={"Editar Incapacidad"} id={objectSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !objectSelected) &&
        <ModalEdit title={"Crear Incapacidad"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default IncapacidadEmpleado;
